import { createSlice } from "@reduxjs/toolkit";
import { fetchInventoryTransferRequest, fetchInventoryTransferRequestHistory } from "./thunk";

interface initialStateType {
  transferRequestList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: initialStateType = {
  transferRequestList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const InventoryTransferRequestSlice = createSlice({
  name: "InventoryTransferRequest",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventoryTransferRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInventoryTransferRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.transferRequestList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchInventoryTransferRequest.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch Purchase Order List";
      })
      .addCase(fetchInventoryTransferRequestHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchInventoryTransferRequestHistory.fulfilled,
        (state, action) => {
          state.loading = false;
          state.transferRequestList = action.payload.data;
          state.rowCount = action.payload.rowCount;
        }
      )
      .addCase(
        fetchInventoryTransferRequestHistory.rejected,
        (state, action) => {
          state.loading = false;
          state.error =
            action.error.message || "Network Error";
        }
      );
  },
});

export default InventoryTransferRequestSlice.reducer;
